import { useEffect, useState } from 'react';
import { programBoardDetail } from '@/network/apis/apiUri';

export default function ProgramAnnouncementView(props) {
  const { mode, selBoard, history, itemId } = props;

  const [detailData, setDetailData] = useState();

  useEffect(() => {
    programBoardDetail({
      board_id: selBoard.boardId,
      board_item_id: itemId,
      hit: true,
    })
      .then((res) => {
        if (res.status === 200) {
          const _data = res.data;
          setDetailData({
            title: _data.title.find((el) => el.lan_code === mode).text,
            content: _data.content.find((el) => el.lan_code === mode).text.replace(/(?:\r\n|\r|\n)/g, '<br />'),
            regDate: _data.reg_date ? _data.reg_date.slice(0, -2) : '',
            hitCount: _data.hit_count,
          });
        }
      })
      .catch(() => setDetailData(undefined));
    return () => setDetailData((prev) => prev);
  }, []);

  if (!detailData) return null;
  return (
    <div id="CommonProgramBoardView" className="commonProgramBoardView">
      <h2 className="commonProgramBoardView_title">{selBoard.title}</h2>
      <div className="commonProgramBoardView_content">
        <div className="commonProgramBoardView_content_title-wrap">
          <div className="title-wrap">
            <h4 className="title">{detailData.title}</h4>
            <div className="info titleStyle_0">
              <span className="info_date time-fs-fixed">{detailData.regDate}</span>
            </div>
          </div>
          <button type="button" className="btnList" onClick={() => history.goBack()}>
            목록
          </button>
        </div>
        <div
          className="commonProgramBoardView_content_info"
          dangerouslySetInnerHTML={{
            __html: detailData.content,
          }}
        />
      </div>
      <div className="commonProgramBoardView_footer">
        <button type="button" className="btnList" onClick={() => history.goBack()}>
          목록
        </button>
      </div>
    </div>
  );
}
